import { useEffect, useRef, useState } from "react";
import {
	ResponsiveContainer,
	BarChart,
	XAxis,
	YAxis,
	Bar,
	ReferenceLine,
	LabelList,
} from "recharts";
import { numberFormatter } from "../../../utils";
import { Progress } from "rsuite";
import "../baseline.scss";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { CSVLink } from "react-csv";

const SupplierSpendByCategory = (props: any) => {
	const [tooltip, setTooltip] = useState<any>({
		supplier: "",
		show: false,
		spend: 0,
		l3: "",
	});
	const { exportData } = props;
	const [supplierExportData, setSupplierExportData] = useState<any>([]);

	const exportDataSupplier = () => {
		let finalData: {
			MasterVendorName: any;
			grossCost: any;
			L1: any;
			L2: any;
			L3: any;
			costPercent: any;
			spendFlag: any;
		}[] = [];
		// finalData.push({ MasterVendorName: " 0 - 14% Gross Margin", gmValue: " " });
		exportData.map((item: any, i: number) => {
			let spendPercentage = 0;
			item.spendPerSupplier.map((sData: any) => {
				if (spendPercentage <= 80) {
					sData.spendFlag = "Top 80%";
				} else {
					sData.spendFlag = "Bottom 20%";
				}
				spendPercentage = spendPercentage + sData.costPercent;
			});
		});

		exportData.map((item: any, i: number) => {
			item.spendPerSupplier.map((supplierData: any) => {
				finalData.push({
					MasterVendorName: supplierData.supplier,
					grossCost: supplierData.cost,
					costPercent: supplierData.costPercent,
					spendFlag: supplierData.spendFlag,
					L1: item.l1,
					L2: item.l2,
					L3: item.l3,
				});
			});
		});

		finalData.sort((x: any, y: any) => y.grossCost - x.grossCost);

		finalData.map((item: any) => {
			item.grossCost = `$${item.grossCost.toFixed(0)}`;
			item.costPercent = `${item.costPercent.toFixed(2)}%`;
		});

		setSupplierExportData(JSON.parse(JSON.stringify(finalData)));
	};

	const exportFullRef = useRef<any>(null);

	const csvHeaders = [
		{ label: "L1", key: "L1" },
		{ label: "L2", key: "L2" },
		{ label: "L3", key: "L3" },
		{ label: "Vendor Name", key: "MasterVendorName" },
		{ label: "Spend", key: "grossCost" },
		{ label: "Spend %", key: "costPercent" },
		{ label: "Top 80% / Bottom 20% Flag", key: "spendFlag" },
	];

	useEffect(() => {
		if (supplierExportData?.length !== 0) {
			exportFullRef?.current?.link.click();
		}
	}, [supplierExportData]);

	useEffect(() => {
		let highestNetcost = props.data.reduce((a: any, value: any) => {
			return (a = a > value.netcost ? a : value.netcost);
		}, 0);

		props.data.map((d: any) => {
			d.netcostPercentage = (d.netcost / highestNetcost) * 100;
		});
	}, [props.data]);

	const onHover = (data: any, index: number) => {
		setTooltip({
			show: true,
			supplier: data.dataKey,
			spend: data.value,
			l3: data.payload.l3,
		});
	};

	const onOut = () => {
		setTooltip({ show: false, supplier: "", spend: "" });
	};

	const renderCustomizedLabel = (props: any) => {
		const { x, y, width, values, height } = props;
		return (
			<>
				{values.supplier.length > 0 && (
					<text
						x={x + width / 2}
						y={
							y -
							(values.supplier.length > 0
								? -(height - 10)
								: -(height - 10))
						}
						// y={2*y}
						fill="#fff"
						textAnchor="middle"
						dominantBaseline="middle"
						className={
							values.supplier.length > 15 &&
							values.costPercent < 55
								? "text-[1.2vh]"
								: "text-[1.5vh]"
						}
					>
						{values.supplier}
					</text>
				)}
			</>
		);
	};

	return (
		<table className=" common-table-ui">
			<thead>
				<tr>
					<th>L3 Categories</th>
					<th>Spend</th>
					<th># Suppliers</th>
					<th colSpan={1}>
						<div className="flex w-full">
							<span className="w-[90%]">% Spend by Supplier</span>
							<div>
								<FileDownloadIcon
									className="ml-[2vh] cursor-pointer"
									style={{
										background: "#9acd32b8",
										borderRadius: ".3vh",
										fill: "#ffff",
									}}
									onClick={() => {
										exportDataSupplier();
									}}
								/>
								<CSVLink
									ref={exportFullRef}
									data={supplierExportData}
									headers={csvHeaders}
									filename="supplierSpendSummary.csv"
									className="hidden"
									target="_blank"
								>
									{" "}
								</CSVLink>
							</div>
						</div>
					</th>
				</tr>
			</thead>
			<tbody>
				{props?.data?.map((d: any, index: any) => {
					if (typeof d.spendPerSupplier === "string") {
						d.spendPerSupplier = JSON.parse(d.spendPerSupplier);
					}
					return (
						<tr key={index} className="h-[8vh]">
							<td
								className="w-[25%] cursor-pointer"
								onClick={() => {
									props.handleClick(d?.l3);
								}}
							>
								{d?.l3}
							</td>
							<td className="w-[8vw] !h-full">
								<div
									style={{
										position: "relative",
										width: "100%",
										height: "4vw",
									}}
								>
									<Progress.Line
										percent={d?.netcostPercentage}
										strokeColor="#86BC25"
										strokeWidth={30}
										showInfo={false}
										style={{
											width: "100%",
											height: "4vw",
										}}
									/>
									<span
										style={{
											position: "absolute",
											left: "50%",
											top: "50%",
											transform: "translate(-50%, -50%)",
											color: "#000000",
											fontWeight: "400",
											fontSize: "0.95em",
											pointerEvents: "none",
											width: "100%",
											textAlign: "center",
										}}
									>
										{numberFormatter(d?.netcost, 0, "$")}
									</span>
								</div>
							</td>
							<td className="w-[12%]">{d?.supplierCount}</td>
							<td className="w-[50%] relative">
								<ResponsiveContainer
									width="100%"
									height="100%"
									maxHeight={50}
									minHeight={"6vh"}
								>
									<BarChart
										data={[d]}
										layout="vertical"
										stackOffset="expand"
									>
										<XAxis hide type="number" />
										<YAxis
											hide
											type="category"
											dataKey="l3"
										/>
										{d?.spendPerSupplier &&
											d?.spendPerSupplier?.map(
												(
													supplier: any,
													ind: number
												) => {
													return (
														<Bar
															key={
																supplier?.supplier
															}
															dataKey={
																supplier?.supplier
															}
															stackId="a"
															onMouseEnter={(
																a: any,
																index
															) =>
																onHover(
																	a
																		.tooltipPayload[0],
																	index
																)
															}
															onMouseLeave={onOut}
															fill={
																supplier.color
															}
														>
															{supplier.costPercent >
																40 && (
																<LabelList
																	dataKey="total"
																	values={
																		supplier
																	}
																	alignmentBaseline="middle"
																	content={
																		renderCustomizedLabel
																	}
																/>
															)}
														</Bar>
													);
												}
											)}
										{
											<ReferenceLine
												x={0.8}
												isFront={true}
												strokeWidth={3}
												label={
													index % 5 == 0 && {
														position: "top",
														fill: "#000",
														value: "80% Spend",
														fontStyle: "italic",
													}
												}
											></ReferenceLine>
										}
									</BarChart>
								</ResponsiveContainer>

								{tooltip.show && tooltip.l3 === d.l3 && (
									<div
										style={{
											position: "absolute",
											left: 0,
											bottom: "7vh",
											zIndex: 999,
											width: "fit-content",
											background: "white",
											border: "1px solid #ccc",
											boxShadow:
												"0 2px 5px rgba(0,0,0,0.2)",
											borderRadius: "1vh",
											color: "black",
											opacity: 0.97,
											padding: 0,
										}}
									>
										{/* Header Row */}
										<div className="w-full flex justify-start h-[3vh] items-center bg-[#f0f4f8] py-[3vh] px-[1vh] textSmall">
											<div className="font-bold uppercase">
												Supplier:
											</div>
											<div
												className="font-bold ml-1"
												style={{ color: "#3f3f3f" }}
											>
												{tooltip.supplier}
											</div>
										</div>
										{/* Data Row */}
										<div className="h-fit p-[1vh] mt-[.5vh] mb-[.5vh]">
											<p
												className="label"
												style={{
													padding: "0",
													margin: "0",
												}}
											>
												<label
													className="graph-label-small"
													style={{
														color: "#5a5a5a",
														fontWeight: "normal",
													}}
												>
													L3 Category:{" "}
												</label>
												<label
													className="graph-label-small"
													style={{
														color: "#3f3f3f",
														fontWeight: "bold",
													}}
												>
													{tooltip.l3}
												</label>
											</p>
											<p
												className="label"
												style={{
													padding: "0",
													margin: "0",
												}}
											>
												<label
													className="graph-label-small"
													style={{
														color: "#5a5a5a",
														fontWeight: "normal",
													}}
												>
													Spend (%):{" "}
												</label>
												<label
													className="graph-label-small"
													style={{
														color: "#3f3f3f",
														fontWeight: "bold",
													}}
												>
													{Number(
														tooltip.spend
													).toFixed(2)}
												</label>
											</p>
										</div>
									</div>
								)}
							</td>
						</tr>
					);
				})}
			</tbody>
		</table>
	);
};

export default SupplierSpendByCategory;
